export function canInvoiceEntityUseStripe(entity?: string | null): boolean {
  return String(entity || '').trim().toLowerCase() !== 'equilibrium engineering pty ltd';
}

export function getVisibleStripePaymentUrl(entity?: string | null, stripePaymentUrl?: string | null): string {
  if (!canInvoiceEntityUseStripe(entity)) {
    return '';
  }

  return String(stripePaymentUrl || '').trim();
}

export function isStripeSurchargeEnabled(stripePaymentUrl?: string | null, stripeSurchargeEnabled?: boolean | null): boolean {
  return Boolean(String(stripePaymentUrl || '').trim()) && stripeSurchargeEnabled !== false;
}

export function formatStripePaymentLabelForPdf(stripePaymentUrl?: string | null, stripeSurchargeEnabled?: boolean | null): string {
  if (!String(stripePaymentUrl || '').trim()) {
    return '';
  }

  return isStripeSurchargeEnabled(stripePaymentUrl, stripeSurchargeEnabled)
    ? 'Stripe Payment (1.7% Stripe Surcharge applies)'
    : 'Stripe Payment';
}
